"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
export default function Projects() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const topics = [{
    title: "Diş Beyazlatma Nedir?",
    content: "Dişlerin yapısındaki gözenekli mine tabakasında oluşan renklenmelerin, özel beyazlatma jelleri ile giderilmesi işlemidir. Kayseri'de sunduğumuz bu tedavi ile dişleriniz doğal ve ışıltılı bir görünüme kavuşur."
  }, {
    title: "Kimler Yaptırabilir?",
    content: "Çay, kahve, sigara kullanımı veya yaşa bağlı renk değişimleri yaşayan, diş ve diş eti sağlığı yerinde olan her yetişkin için uygundur. Kayseri Diş Kliniğimizde yapılan muayene ile işleme uygunluk teyit edilir."
  }, {
    title: "Tedavi Süreci",
    content: "Diş Muayenesi: Çürük ve diş eti problemleri değerlendirilir. Temizlik (Gerekirse): Diş taşı ve plak temizliği yapılır. Beyazlatma Uygulaması: Özel jel ve ışık sistemi ile işlem gerçekleştirilir. Sonuç Değerlendirme: İşlem sonrası ton farkı gözlemlenir"
  }, {
    title: "Hassasiyet ve Konfor\n\xA0\xA0",
    content: "Kayseri'deki hastalarımızın en çok merak ettiği konu hassasiyettir. Modern tekniklerimiz ve koruyucu jellerimiz sayesinde diş minesine zarar vermeden, minimum hassasiyet ve maksimum konforla işlemi tamamlıyoruz."
  }, {
    title: "Kayseri Diş Beyazlatma Fiyatları 2026",
    content: "Diş beyazlatma fiyatları; uygulama yöntemine, seans sayısına ve kullanılan materyalin kalitesine göre belirlenir. 2026 yılı güncel Kayseri diş beyazlatma fiyatları hakkında detaylı bilgi almak için bizimle iletişime geçebilirsiniz."
  }, {
    title: "Neden Bizi Seçmelisiniz?",
    content: "Kayseri'deki modern kliniğimizde, hasta memnuniyeti odaklı yaklaşımımız, güncel teknoloji kullanımımız ve premium materyal seçimimizle estetik ve kalıcı sonuçlar sunuyoruz."
  }];
  return <section data-section-id="184775" id="kayseri-implant-tedavisi" className="relative bg-linear-to-b from-background to-secondary/20 py-32 md:py-48 lg:py-56 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        <div ref={headerRef} className={`flex flex-col items-center text-center max-w-4xl mx-auto mb-20 md:mb-32 transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="font-sans text-xs md:text-sm font-semibold tracking-widest uppercase text-primary mb-6">
            Öne Çıkan Tedavilerimiz
          </span>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-8xl text-foreground leading-tight tracking-tight">Kayseri Diş Beyazlatma Tedavisi</h2>
          <Separator className="w-24 bg-primary/40 mt-10" />
        </div>

        <div className={`transition-all duration-1000 delay-300 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <p className="max-w-3xl mx-auto text-center font-sans text-lg md:text-xl text-muted-foreground leading-relaxed mb-16 md:mb-24">
            Kayseri’de daha ışıltılı ve estetik bir gülüşe sahip olmak istiyorsanız, profesyonel diş beyazlatma (bleaching) tedavisi en etkili yöntemdir. Dişlerinize zarar vermeden uygulanan modern tekniklerle, hayalinizdeki beyazlığa konforla ulaşmanızı sağlıyoruz.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
            {topics.map((topic, i) => <Card key={i} data-index={i} className="group bg-card/50 backdrop-blur-sm border-none shadow-sm hover:shadow-md hover:bg-secondary/30 transition-all duration-500">
                <CardHeader className="pb-4">
                  <CardTitle className="leading-none font-semibold font-serif text-foreground group-hover:text-primary transition-colors duration-300 !text-[26px] !w-[340px]">
                    {topic.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-sans text-muted-foreground leading-relaxed">
                    {topic.content}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>

      </div>
    </section>;
}